import { GEOLOCATION_RULES } from '../constants.js';

/**
 * Used for determining the if current region is using the optOut framework
 * It follows the following logic in order:
 * 1) If there's no geolocation rule for the specified region
 *  then use the rule for DEFAULT region
 *  - Otherwise use the DEFAULT_FRAMEWORK
 * 2) Use geolocation rule
 */

/**
 * optIn: Users must opt in to tracking (EU)
 * optOut: Users must opt out of tracking (non-EU)
 * We use the most restrictive framework (optIn) if we don't know the framework
 */
const DEFAULT_FRAMEWORK = 'optIn';
const isOptOut = region => {
  const rule = GEOLOCATION_RULES.find(r => r.region === region);
  if (!rule) {
    const defaultRule = GEOLOCATION_RULES.find(r => r.region === 'DEFAULT');
    if (defaultRule?.framework) {
      return defaultRule.framework === 'optOut';
    }
    // @ts-expect-error: 2021-03-20: Whitelisted type error. To be corrected after typescript migration.
    return DEFAULT_FRAMEWORK === 'optOut';
  }
  return rule.framework === 'optOut';
};
export { isOptOut as default };
//# sourceMappingURL=isOptOut.js.map
